export default __webpack_public_path__ + "static/media/url.6b5ba6ee.svg";